var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6504 0.991817C13.4339 0.998268 13.2284 1.08875 13.0775 1.2441L4.50003 9.82157L1.75589 7.07743C1.6791 6.99745 1.58713 6.9336 1.48535 6.88961C1.38358 6.84562 1.27405 6.82239 1.16318 6.82126C1.05232 6.82013 0.94234 6.84114 0.839692 6.88304C0.737044 6.92495 0.64379 6.98692 0.565391 7.06532C0.486992 7.14372 0.425024 7.23697 0.383117 7.33962C0.341209 7.44227 0.320204 7.55224 0.321332 7.66311C0.32246 7.77398 0.345698 7.8835 0.389686 7.98528C0.433673 8.08705 0.497526 8.17903 0.577503 8.25581L3.91084 11.5891C4.06712 11.7454 4.27905 11.8331 4.50003 11.8331C4.72101 11.8331 4.93294 11.7454 5.08922 11.5891L14.2559 2.42248C14.3763 2.30543 14.4586 2.15473 14.4919 1.99013C14.5252 1.82553 14.508 1.65471 14.4425 1.50005C14.3771 1.3454 14.2664 1.21412 14.1251 1.12343C13.9837 1.03274 13.8183 0.986867 13.6504 0.991817Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarked);
export default __webpack_public_path__ + "static/media/marked.418430378ea6d27378ddbc6d4327ab47.svg";
export { ForwardRef as ReactComponent };